import React from 'react';
import { CFooter } from '@coreui/react';
import moment from 'moment';

const TheFooter = () => {
  return (
    <CFooter fixed={false} className="footer">
      <div className="mfs-auto footer-color-theme">
        &copy; Shizen Connect Inc. All Rights Reserved.
      </div>
    </CFooter>
  );
};

export default React.memo(TheFooter);
